import { keyframes } from "@emotion/react";

/** Brand indigo → purple → pink gradient for the version-update prompt accents. */
export const VERSION_UPDATE_PROMPT_GRADIENT = "linear-gradient(90deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)";

/** Full-turn rotation for the version-update prompt's in-progress spinner. */
export const VERSION_UPDATE_PROMPT_SPIN = keyframes({ to: { transform: "rotate(360deg)" } });
